import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import RememberPassword from '../../components/IndexPage/RememberPassword/Index';
function mapDispatchToProps(_ref) {
  var rememberPassword = _ref.rememberPassword,
    indexPage = _ref.indexPage;
  return {
    rememberPassword: rememberPassword,
    indexPage: indexPage
  };
}
var RememberPasswordR = _Form.create()(RememberPassword);
export default connect(mapDispatchToProps)(RememberPasswordR);